import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentUploadService {

  constructor(private ws: PostmethodService) { }

  uploadDocument(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.loginUrl + "/head-office/upload-document");
  }

  getDocument(data: any) {
    // return this.ws.wsPost(data, environment.loginUrl + "/head-office/document-listing");
    return this.ws.wsGet(environment.loginUrl + "/head-office/document-listing");
  }

  documentStatus(request:any) {
    return this.ws.wsPost(request, environment.loginUrl + "/head-office/document-status");
  }

  updatedocumentStatus(request:any) {
    return this.ws.wsPost(request, environment.loginUrl + "/head-office/update-document-status");
  }
}
